import {DialogTitle, Divider, IconButton, Stack} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {type ReactNode} from 'react';

const DialogTitleWithClose = (props: DialogTitleProps) => {
  const {children, onClose, ...other} = props;

  return (
    <>
      <DialogTitle {...other} sx={{p: 0}}>
        <Stack direction="row" p={0} justifyContent="space-between" alignItems="center">
          <Stack direction="row" py={2} pl={3}>
            {children}
          </Stack>
          {onClose ? (
            <Stack direction="row" alignSelf="stretch">
              <Divider orientation="vertical" flexItem />
              <Stack p={1}>
                <IconButton onClick={onClose} data-testid="close-modal">
                  <CloseIcon color="secondary" />
                </IconButton>
              </Stack>
            </Stack>
          ) : null}
        </Stack>
      </DialogTitle>
      <Divider />
    </>
  );
};

export default DialogTitleWithClose;

export interface DialogTitleProps {
  children?: ReactNode;
  onClose: () => void;
}
